/* global Promise grecaptcha */
'use strict';

var httpClient = require('../../../commons/httpClient').httpClient;
var store = require('adyen_config/store');
var helpers = require('../../../checkout/helpers');
var constants = require('adyen_config/constants');
var APPLE_PAY = constants.APPLE_PAY;
var initCheckout = require('../../initializeCheckout');
var initializeCheckout = initCheckout.initializeCheckout;
var adyenCommons = require('../../../commons');
var createTemporaryBasket = adyenCommons.createTemporaryBasket;

function ApplePay(config, applicationInfo, adyenTranslations, isExpressPdp, initialAmount) {
    var basketAmount = window.basketAmount;
    var showConfirmationAction = window.showConfirmationAction;
    var shippingMethodsUrl = window.shippingMethodsUrl;
    var selectShippingMethodUrl = window.selectShippingMethodUrl;
    var paymentFromComponentURL = window.paymentFromComponentURL;

    this.store = store;
    this.helpers = helpers;
    this.amount = initialAmount || JSON.parse(basketAmount);
    this.showPayButton = true;
    this.isExpress = true;
    this.isExpressPdp = isExpressPdp;
    this.paymentFromComponentURL = paymentFromComponentURL;
    this.showConfirmationAction = showConfirmationAction;
    this.shippingMethodsUrl = shippingMethodsUrl;
    this.selectShippingMethodUrl = selectShippingMethodUrl;
    this.applicationInfo = applicationInfo;
    this.config = config;
    this.customerData = null;
    this.billingData = null;
    this.translations = adyenTranslations;
    this.APPLE_PAY_SUCCESS = 1;
    this.APPLE_PAY_ERROR = 0;
}

ApplePay.prototype.formatAddress = function (data) {
    return {
        address1: this[data].addressLines[0],
        address2: this[data].addressLines.length > 1 ? this[data].addressLines[1] : null,
        city: this[data].locality,
        countryCode: {
            displayValue: this[data].country,
            value: this[data].countryCode
        },
        firstName: this[data].givenName,
        lastName: this[data].familyName,
        postalCode: this[data].postalCode,
        stateCode: this[data].administrativeArea
    };
};

ApplePay.prototype.formatCustomerObject = function () {
    var customerData = this.customerData;
    var address = this.formatAddress('customerData');
    address.ID = customerData.emailAddress;

    return {
        addressBook: {
            addresses: {},
            preferredAddress: address
        },
        billingAddressDetails: this.formatAddress('billingData'),
        customer: {},
        profile: {
            firstName: customerData.givenName,
            lastName: customerData.familyName,
            email: customerData.emailAddress,
            phone: customerData.phoneNumber
        }
    };
};

ApplePay.prototype.handleAuthorised = function (response, resolve) {
    resolve({
        resultCode: response ? response.resultCode : null
    });
    if (document.querySelector('#result')) {
        var fullResponse = response.fullResponse || {};
        document.querySelector('#result').value = JSON.stringify({
            pspReference: fullResponse.pspReference,
            resultCode: fullResponse.resultCode,
            // eslint-disable-next-line no-nested-ternary
            paymentMethod: fullResponse.paymentMethod
                ? fullResponse.paymentMethod
                : (fullResponse.additionalData ? fullResponse.additionalData.paymentMethod : ''),
            donationToken: fullResponse.donationToken,
            amount: fullResponse.amount,
            fullResponse: fullResponse
        });
    }
    if (document.querySelector('#showConfirmationForm')) {
        document.querySelector('#showConfirmationForm').submit();
    }
};

ApplePay.prototype.handleError = function (rejectApplePay, response) {
    rejectApplePay({
        status: this.APPLE_PAY_ERROR
    });
    if (response && response.dataError) {
        if (document.querySelector('.express-error-msg') && document.querySelector('.express-error-msg .error-message-text')) {
            document.querySelector('.express-error-msg').classList.remove('d-none');
            document.querySelector('.express-error-msg .error-message-text').textContent = response.dataError;
        }
        return;
    }
    if (document.querySelector('#result')) {
        document.querySelector('#result').value = JSON.stringify({
            error: true
        });
    }
    if (document.querySelector('#showConfirmationForm')) {
        document.querySelector('#showConfirmationForm').submit();
    }
};

ApplePay.prototype.handleApplePayResponse = function (response, resolveApplePay, rejectApplePay) {
    if (response && response.resultCode === 'Authorised') {
        this.handleAuthorised(response, resolveApplePay);
    } else {
        this.handleError(rejectApplePay, response);
    }
};

ApplePay.prototype.callPaymentFromComponent = function (data) {
    return httpClient({
        url: this.paymentFromComponentURL,
        method: 'POST',
        data: {
            data: JSON.stringify(data),
            paymentMethod: APPLE_PAY
        }
    });
};

ApplePay.prototype.selectShippingMethod = function (method) {
    var requestBody = {
        paymentMethodType: APPLE_PAY,
        shipmentUUID: method.shipmentUUID,
        methodID: method.ID,
        isExpressPdp: this.isExpressPdp
    };
    return httpClient({
        method: 'POST',
        url: this.selectShippingMethodUrl,
        data: {
            data: JSON.stringify(requestBody)
        }
    });
};

ApplePay.prototype.getShippingMethod = function (shippingContact) {
    var requestBody = {
        paymentMethodType: APPLE_PAY,
        isExpressPdp: this.isExpressPdp
    };
    if (shippingContact) {
        requestBody.address = {
            city: shippingContact.locality,
            country: shippingContact.country,
            countryCode: shippingContact.countryCode,
            stateCode: shippingContact.administrativeArea,
            postalCode: shippingContact.postalCode
        };
    }
    return httpClient({
        method: 'POST',
        url: this.shippingMethodsUrl,
        data: {
            data: JSON.stringify(requestBody)
        }
    });
};

ApplePay.prototype.onAuthorized = function (data, actions) {
    var self = this;
    var authorizedEvent = data.authorizedEvent;
    var customerData = authorizedEvent.payment.shippingContact;
    var pageAction = $('.page').data('action');
    var cartPageNavigationURL = $('#cartPageNavigation').val();

    // Custom Peter Millar: Hazardous materials check for AK/HI states
    if (
        (customerData.administrativeArea === 'AK' ||
            customerData.administrativeArea === 'HI') &&
        $('#isHazardousProducts').val() === 'true'
    ) {
        sessionStorage.setItem('stateCodeFromApplePay', customerData.administrativeArea);
        if (pageAction && pageAction !== 'Checkout-Begin') {
            sessionStorage.setItem('applePayEmail', customerData.emailAddress);
        }

        if (pageAction && pageAction !== 'Cart-Show' && pageAction !== 'Checkout-Begin' && cartPageNavigationURL) {
            location.assign(cartPageNavigationURL);
        } else {
            location.reload();
        }
        return;
    }

    // Custom Peter Millar: Valid countries check
    var validCountries = $('#validCountryCodes').val();
    var validCountriesArray;
    if (validCountries) {
        try {
            validCountriesArray = JSON.parse(validCountries);
        } catch (error) {
            validCountriesArray = null;
        }
    }
    var countryCode = customerData.countryCode ? customerData.countryCode.toUpperCase() : '';
    if (validCountriesArray && Array.isArray(validCountriesArray)) {
        validCountriesArray = validCountriesArray.map(function (item) {
            return (typeof item === 'object' && item.countryCode) ? item.countryCode.toUpperCase() : String(item).toUpperCase();
        });
    }

    if (validCountriesArray && Array.isArray(validCountriesArray) && validCountriesArray.indexOf(countryCode) === -1) {
        sessionStorage.setItem('countryIsNotValid', countryCode);
        if (pageAction && pageAction !== 'Cart-Show' && pageAction !== 'Checkout-Begin' && cartPageNavigationURL) {
            location.assign(cartPageNavigationURL);
        } else {
            location.reload();
        }
        return;
    }

    // Custom Peter Millar: reCAPTCHA integration
    var siteKey = $('.recaptcha-place').find('.custom-recaptcha-response').data('sitykey');
    var action = $('.recaptcha-place').find('.custom-recaptcha-response').data('action');

    var recaptchaPromise = Promise.resolve();
    if (siteKey && siteKey !== '') {
        recaptchaPromise = new Promise(function (resolveRecaptcha) {
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, { action: action }).then(function (token) {
                    $('.recaptcha-place').find('.custom-recaptcha-response').val(token);
                    resolveRecaptcha();
                });
            });
        });
    }

    recaptchaPromise.then(function () {
        try {
            self.customerData = authorizedEvent.payment.shippingContact;
            self.billingData = authorizedEvent.payment.billingContact;
            self.customer = self.formatCustomerObject();
            actions.resolve();
        } catch (error) {
            actions.reject();
        }
    });
};

ApplePay.prototype.onSubmit = function (state, component, actions) {
    var self = this;
    var resolve = actions.resolve;
    var reject = actions.reject;
    var stateData = $.extend({}, state.data, {
        paymentType: 'express'
    });
    // Custom Peter Millar: Skip Adyen Risk
    // stateData.additionalData = {
    //     'riskdata.skipRisk': 'true'
    // };

    var recaptchaToken = $('.recaptcha-place').find('.custom-recaptcha-response').val();

    return this.callPaymentFromComponent($.extend({}, stateData, {
        customer: this.customer,
        isExpressPdp: this.isExpressPdp,
        recaptchaToken: recaptchaToken
    })).then(function (response) {
        helpers.createShowConfirmationForm(self.showConfirmationAction);
        if (self.isExpressPdp) {
            self.helpers.setExpressRedirectUrl();
        }
        helpers.setOrderFormData(response);
        if (document.querySelector('#additionalDetailsHidden')) {
            document.querySelector('#additionalDetailsHidden').value = JSON.stringify(stateData);
        }
        self.handleApplePayResponse(response, resolve, reject);
    });
};

ApplePay.prototype.onShippingMethodSelected = function (resolve, reject, event) {
    var self = this;
    var shippingMethod = event.shippingMethod;
    return this.getShippingMethod().then(function (shippingMethodsData) {
        var shippingMethods = shippingMethodsData ? shippingMethodsData.shippingMethods : null;
        var matchingShippingMethod = shippingMethods ? shippingMethods.find(function (sm) {
            return sm.ID === shippingMethod.identifier;
        }) : null;

        return self.selectShippingMethod(matchingShippingMethod).then(function (calculationResponse) {
            if (calculationResponse && calculationResponse.grandTotalAmount) {
                resolve({
                    newTotal: {
                        type: 'final',
                        label: self.config.merchantName,
                        amount: calculationResponse.grandTotalAmount.value
                    }
                });
            } else {
                reject();
            }
        });
    });
};

ApplePay.prototype.onShippingContactSelected = function (resolve, reject, event) {
    var self = this;
    var shippingContact = event.shippingContact;

    function handleInvalidAddress() {
        window.console.log('Apple Pay Express: Invalid shipping address or no methods found', shippingContact);
        var error = new window.ApplePayError(
            'shippingContactInvalid',
            'postalAddress',
            'No shipping methods available for this address. Please check your address.'
        );
        resolve({
            errors: [error],
            newTotal: {
                type: 'final',
                label: self.config.merchantName,
                amount: self.amount.value / Math.pow(10, window.fractionDigits)
            }
        });
    }

    // eslint-disable-next-line consistent-return
    return this.getShippingMethod(shippingContact).then(function (shippingMethodsData) {
        if (shippingMethodsData && shippingMethodsData.shippingMethods && shippingMethodsData.shippingMethods.length) {
            var selectedShippingMethod = shippingMethodsData.shippingMethods[0];
            return self.selectShippingMethod(selectedShippingMethod).then(function (newCalculation) {
                if (newCalculation && newCalculation.grandTotalAmount) {
                    var shippingMethodsStructured = shippingMethodsData.shippingMethods.map(function (sm) {
                        return {
                            label: sm.displayName,
                            detail: sm.description,
                            identifier: sm.ID,
                            amount: String(sm.shippingCost.value)
                        };
                    });

                    // Custom Peter Millar: Reorder shipping methods to put selected one first
                    var selectedIndex = -1;
                    for (var i = 0; i < shippingMethodsStructured.length; i++) {
                        if (shippingMethodsStructured[i].identifier === selectedShippingMethod.ID) {
                            selectedIndex = i;
                            break;
                        }
                    }
                    if (selectedIndex !== -1) {
                        var selectedMethod = shippingMethodsStructured.splice(selectedIndex, 1)[0];
                        shippingMethodsStructured.unshift(selectedMethod);
                    }

                    resolve({
                        newShippingMethods: shippingMethodsStructured,
                        newTotal: {
                            type: 'final',
                            label: self.config.merchantName,
                            amount: newCalculation.grandTotalAmount.value
                        }
                    });
                } else {
                    reject();
                }
            });
        }
        handleInvalidAddress();
    }, function () {
        handleInvalidAddress();
    });
};

ApplePay.prototype.onClick = function (resolve, reject) {
    var self = this;
    if (this.isExpressPdp) {
        return createTemporaryBasket().then(function (tempBasketResponse) {
            if (tempBasketResponse && tempBasketResponse.temporaryBasketCreated) {
                resolve({
                    newTotal: {
                        type: 'final',
                        label: self.config.merchantName,
                        amount: tempBasketResponse.amount.value
                    }
                });
            } else {
                reject();
            }
        });
    }
    return resolve();
};

ApplePay.prototype.getConfig = function () {
    return {
        configuration: this.config,
        showPayButton: this.showPayButton,
        amount: this.amount,
        isExpress: this.isExpress,
        requiredShippingContactFields: ['postalAddress', 'email', 'phone'],
        requiredBillingContactFields: ['postalAddress', 'phone'],
        onSubmit: this.onSubmit.bind(this),
        onClick: this.onClick.bind(this),
        onAuthorized: this.onAuthorized.bind(this),
        onShippingMethodSelected: this.onShippingMethodSelected.bind(this),
        onShippingContactSelected: this.onShippingContactSelected.bind(this)
    };
};

ApplePay.prototype.getComponent = function () {
    var self = this;
    return initializeCheckout(
        this.applicationInfo,
        this.translations
    ).then(function (checkout) {
        var applePayConfig = self.getConfig();
        return window.AdyenWeb.createComponent(APPLE_PAY, checkout, applePayConfig);
    });
};

module.exports = ApplePay;
